// The time formats the events-and-shifts import accepts, as CSVBox regex validators.
//
// Two shapes, each with hours bounded so nothing reaches the backend that
// `ActiveSupport::TimeZone#parse` would raise on (an hour above 23 raises
// `ArgumentError: hour out of range` inside the webhook request):
//
//   12-hour  `9:00AM`, `9:00 am`, `12:30 PM`  — hour 1–12, optional space, any-case AM/PM
//   24-hour  `9:00`, `09:00`, `14:00`, `0:00`  — hour 0–23, no suffix
//
// `Api::Imports::Adapters::EventAdapter#generate_datetime` parses both.
const TWELVE_HOUR = '(?:0?[1-9]|1[0-2]):[0-5]\\d\\s?[AaPp][Mm]'
const TWENTY_FOUR_HOUR = '(?:[01]?\\d|2[0-3]):[0-5]\\d'

export const IMPORT_TIME_REGEX_STRING = `^(?:${TWELVE_HOUR}|${TWENTY_FOUR_HOUR})$`

export const IMPORT_TIME_REGEX = new RegExp(IMPORT_TIME_REGEX_STRING)
